import React, {useEffect, useRef} from 'react';
import useMortgage from "./useMortgage";
import dayjs from "dayjs";
import {
    ApplicationStages,
    ApplicationStatuses,
    BuildType,
    ContactMethods,
    MortgageQualificationStatus,
    MortgageTypes,
    ProgressViewState
} from "../../../models";
import {Tag} from "antd";
import TagInfo from "../../components/elements/TagInfo";
import {CheckSquareOutlined, CloseSquareOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {red, green, orange} from "@ant-design/colors";
export const valuation2RequiredNow = (mortgage) => {
    const prevValuationExpiry = mortgage.property?.valuationExpiryDate ? dayjs(mortgage.property.valuationExpiryDate) : null
    const secondNeeded = mortgage.property?.anotherValuationNeeded
    const newBuild = mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.property.buildType === BuildType.NEW
    const snagDate = mortgage.property?.snagDate ? dayjs(mortgage.property.snagDate) : null
    const drawdownDate = mortgage.activeSubmission?.drawdownDate ? dayjs(mortgage.activeSubmission.drawdownDate) : null
    if (newBuild) {
        if (snagDate && snagDate.isBefore(dayjs())) {
            // snag date passed, so valuation needed
            return true
        }
    }
    else{
        if (prevValuationExpiry && prevValuationExpiry.isBefore(dayjs().subtract(10,'days'))) {
            // valuation expired, so new one needed
            return true
        }
        if (secondNeeded || (prevValuationExpiry && drawdownDate && prevValuationExpiry.isBefore(drawdownDate))) {
            return true
        }
    }
    return false
}
export const lenderFlowDefaults = (lenderCode) => {
    const obj = {
        aipTakingTooLongInDays: 12,
        loanOfferRequestTakingTooLongInDays: 12,
        aipValidityInMonths: 6,
    }
    switch (lenderCode) {
        case 'haven':
            obj.aipValidityInMonths = 12
            break
        default:
    }
    return obj
}
export const itemsDoneBySubmission = (submissionID) => {
    const ItemsDone = {
        // User       : {
        // 	// affordabilityComplete    : mortgage.twoApplicants ? userComplete('app1AffordabilityComplete') && userComplete('app2AffordabilityComplete') ? userComplete('app2AffordabilityComplete') : false : userComplete('app1AffordabilityComplete'),
        // 	// app1AffordabilityComplete: userComplete('app1AffordabilityComplete'),
        // 	// app2AffordabilityComplete: userComplete('app2AffordabilityComplete'),
        // 	// callScheduled            : userComplete('ApplyCallScheduled'),
        // 	// chatComplete             : userComplete('ApplyChatComplete'),
        // 	// valuationInstructed      : userComplete('valuationInstructed', mortgage.activeSubmission?.id),
        // 	// healthComplete           : userComplete('healthComplete'),
        // 	// propertyComplete         : userComplete('propertyComplete', mortgage.activeSubmission?.id),
        // 	// solicitorComplete        : userComplete('solicitorComplete'),
        // 	// productSelectionComplete : userComplete('productSelectionComplete'),
        // 	// confirmedMpiTranscript   : userComplete('confirmedMpiTranscript'),
        // },
        UserSource: {
            app1AffordabilityComplete: [
                "App 1's Setup Questions Complete", null
            ], //ok
            app2AffordabilityComplete: [
                "App 2's Setup Questions Complete", null
            ], //ok
            callScheduled: [
                'Schedule A Call', null, 'ApplyCallScheduled' //ok
            ], //ok
            chatComplete: [
                'Mark Chat Complete', null, 'ApplyChatComplete'
            ], //ok
            healthComplete: [
                'Health Complete', null,
            ], //ok
            solicitorComplete: [
                'Solicitor Complete', null
            ],
            valuationInstructed: [
                'Valuation Instructed', submissionID
            ], //ok
            propertyComplete: [
                'Property Complete', submissionID
            ], //ok
            productSelectionComplete: [
                'Product Selection Complete', submissionID
            ], //ok
            confirmedMpiTranscript: [
                'User To Confirm MPI Transcript', submissionID
            ],
            ApplicationSubmitted: [
                'Package & Submit Application', submissionID
            ],
            deedOfAssignmentPosted: [
                'Haven Deed Of Assignment Posted', submissionID
            ],
            LoanOfferSubmitted: ['Loan Offer Submitted', submissionID],
        }, // Admin      : {},
        AdminSource: {
            applyUploadsVerified: [
                'Verify All Uploads', submissionID
            ],
            incompleteEmailSent: [
                'Send Incomplete Email', null
            ], //ok
            incompleteReminderEmailSent: [
                'Send Incomplete Reminder Email', null
            ], //ok
            initialAffordabilityTested: [
                'Do Lender Tests', null
            ], //ok
            qualificationEmailSent: [
                'Send Qualification Email', null
            ], //ok
            qualificationReminderEmailSent: [
                'Send Qualification Reminder Email', null
            ],
            qualificationOutstandingUploadsEmail1Sent: [
                'Send Qualification Uploads Outstanding 1 Email', null
            ],
            qualificationOutstandingUploadsEmail2Sent: [
                'Send Qualification Uploads Outstanding 2 Email', null
            ],
            qualificationOutstandingUploadsEmail3Sent: [
                'Send Qualification Uploads Outstanding 3 Email', null
            ],
            verificationOutstandingEmailReminder1Sent: ['Send Verification Items Outstanding 1 Email', null],
            verificationOutstandingEmailReminder2Sent: ['Send Verification Items Outstanding 2 Email', null],
            verificationOutstandingEmailReminder3Sent: ['Send Verification Items Outstanding 3 Email', null],
// HOW DOES CHANGE OF PROPERTY CHANGE FLOW?
            readyForVerifiedFiguresEvaluation: [
                'Ready For Verified Figures Evaluation', null
            ],
            verifiedFiguresEvaluated: [
                'Check Verified Figures', null
            ],  //ok
            // Start Submission Specific
            signingAffordabilityTested: [
                'Do Final Lender Test', submissionID
            ], //okftoo ƒ
            createApplyCustomerDocuments: [
                'Generate Signing Customer Documents', submissionID
            ],
            applyReadyForTransfer: ['Mark Ready For Transfer', submissionID],
            applyTransferred: ['Transfer to CL', submissionID],
            applyPackaged: ['Package Initial Submission', submissionID], //ok
            aipReceivedEmailSent: ['Send AIP Received Email', submissionID],
            mpiQuotesGenerated: ['Generate MPI Quotes & Transcript', submissionID],
            mpiQuotesEmailSent: ['Send MPI Quotes Email', submissionID],
            mpiQuotesReminder1EmailSent: ['Send MPI Quotes Reminder 1 Email', submissionID],
            mpiQuotesReminder2EmailSent: ['Send MPI Quotes Reminder 2 Email', submissionID],
            mpiTranscriptUploaded: ['Upload MPI Transcript', submissionID],
            mpiTranscriptEmailSent: ['Send MPI Transcript Email', submissionID],
            mpiFinalised: ['Finalise MPI', submissionID],
            mpiUnderwritingSubmitted: ['Submit MPI for Underwriting', submissionID],
            mpiUnderwritten: ['Upload Underwritten Quote', submissionID],
            mpiActivated: ['Activate MPI', submissionID],
            healthQuestionsReminderEmailSent: ['Send Health Questions Reminder Email', submissionID],
            healthQuestionsReminder2EmailSent: ['Send Health Questions Reminder 2 Email', submissionID],
            preapprovedOutstandingItemsEmailSent: ['Send Preapproved Outstanding Items Email', submissionID],
            preapprovedCustomerDocsGenerated: ['Generate PreApproved Customer Docs', submissionID],
            preapprovedPackaged: ['Package Loan Offer Request', submissionID], //ok
            loanOfferRequestedEmailSent: ['Send Loan Requested Email', submissionID], //ok
            initiateLoanOfferExtension: [
                'Initiate Loan Offer Extension', submissionID
            ],
            aipAboutToExpiryEmailSent: ['Send AIP About To Expiry Email', submissionID],
            noPropertyAt2MthFromExpiryEmailSent: ['Send No Property At 9 Wks Out Email', submissionID],
            approvedCustomerDocsGenerated: ['Generate Loan Offer Customer Docs', submissionID], // i think this is typo
            approvedCustomerDocumentsGenerated:['Generate Loan Offer Customer Docs', submissionID],
            approvedAdminDocsGenerated: ['Generate Loan Offer Admin Docs', submissionID],

            valuationAboutToExpiryEmailSent: ['Send Valuation About To Expiry Email', submissionID],
            valuation2AboutToExpiryEmailSent: ['Send Valuation About To Expiry Email', submissionID],
            secondValuationNeededAfterSnagEmailSent: ['Send Final Valuation Needed After Snag  Email', submissionID],

            loanOfferAboutToExpiryEmailSent: ['Send Loan Offer About To Expiry Email', submissionID],
            loanOfferReceivedEmailSent: ['Send Loan Offer Received Email', submissionID],
            approvedPackaged: ['Package Closing Documents', submissionID], //ok
            closingDocsEmailSent: ['Send Closing Docs Submitted Email', submissionID], //ok
            mortgageCompleteEmailSent: ['Send Mortgage Complete Email', submissionID], //ok
            allCustomerClosingDocsComplete: ['All Customer Closing Docs Complete', submissionID],
            fixedRateFallingOffEmailSent:['Send Fixed Rate Falling Off Email'],
            rateChangedWhilstInApprovalEmailSent:['Send Rate Changed Whilst In Approval Email', submissionID],
            resetStatementAlignmentDate:['Reset Statement Alignment Date'],
            // Start Closing Specific
            'uploaded-mortgage-protection-policy-cert': ['Uploaded MPI Policy Cert', submissionID],
            'uploaded-statement-of-suitability': ['Statement of suitability uploaded', submissionID],
            'uploaded-signed-direct-debit-mandate': ['Signed Direct Debit Mandate uploaded', submissionID],
            'uploaded-signed-pre-drawdown-paye': ['Pre DrawDown for PAYE uploaded', submissionID],
            'uploaded-signed-pre-drawdown-self-employed': ['Pre DrawDown for Self Employed uploaded', submissionID],

        }
    }
    return ItemsDone
}
export const flowRite = (mortgage, currentRates=[]) => {
    const lastTimeSomeoneWasHere = (()=>{
        const app1 = mortgage.applicant1?.lastHereTime?.time ? dayjs(mortgage.applicant1.lastHereTime.time) : null
        const app2 = mortgage.applicant2?.lastHereTime?.time ? dayjs(mortgage.applicant2.lastHereTime.time) : null
        const mostRecent = [app1, app2].filter(it => it !== null).sort((a, b) => b - a)[0]
        return mostRecent ?? null
    })()
    const today = dayjs()
    const loggedOut = dayjs(mortgage.lastHere).add(2, 'hour').isBefore(dayjs())  // has it been 2 hours since last seen
    const aipReceived = mortgage.activeSubmission?.aipDate
    let aipExpiry = mortgage.activeSubmission?.aipExpiryDate ? dayjs(mortgage.activeSubmission?.aipExpiryDate, 'YYYY-MM-DD') : null
    let aipExtensions = mortgage.activeSubmission?.aipSettings?.extensions
    if (aipExtensions?.length && aipExtensions[aipExtensions.length - 1]?.expiryDate) {
        aipExpiry = dayjs(aipExtensions[aipExtensions.length - 1].expiryDate, 'YYYY-MM-DD')
    }

    // TO DO : if extension received ...
    const valuationExpiry =  mortgage.property?.valuationExpiryDate ? dayjs(mortgage.property?.valuationExpiryDate, 'YYYY-MM-DD') : null
    const valuation2Expiry = mortgage.property?.valuation2ExpiryDate ? dayjs(mortgage.property?.valuation2ExpiryDate, 'YYYY-MM-DD') : null
    const snagRequired = mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.property?.buildType === BuildType.NEW
    const snagDate = mortgage.property?.snagDate ? dayjs(mortgage.property?.snagDate, 'YYYY-MM-DD'): null
    const secondHandProperty = mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.property?.buildType === BuildType.SECONDHAND
    const secondNeeded = mortgage.property?.anotherValuationNeeded
    const newBuild = mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.property?.buildType === BuildType.NEW

    const drawdownDate = mortgage.activeSubmission?.drawdownDate ? dayjs(mortgage?.activeSubmission?.drawdownDate, 'YYYY-MM-DD') : null
    const valuationDocReceived = mortgage.property?.valuationDate

    let loanOfferExpiry = mortgage.activeSubmission?.loanOfferExpiryDate ? dayjs(mortgage.activeSubmission?.loanOfferExpiryDate, 'YYYY-MM-DD') : null
    let loanOfferExtensions = mortgage.activeSubmission?.loanOfferSettings?.extensions
    if (loanOfferExtensions?.length && loanOfferExtensions[loanOfferExtensions.length - 1]?.expiryDate) {
        loanOfferExpiry = dayjs(loanOfferExtensions[loanOfferExtensions.length - 1].expiryDate, 'YYYY-MM-DD')
    }


    const loanOfferReceived = mortgage.activeSubmission?.loanOfferDate
    const propertyFound = mortgage.property?.addressKnown
    const dontContact = mortgage?.requirement?.contactMethod === ContactMethods.DONT
    const inSetup = mortgage.applicationStage === 'SETUP'

    let aipState = null
    let loanOfferState = null
    let valuationState = null
    let expectedAipDate = mortgage.activeSubmission?.expectedAipDate ? dayjs(mortgage.activeSubmission?.expectedAipDate, 'YYYY-MM-DD') : null
    if (mortgage.activeSubmission?.aipExpiryDate) {
        let aipExpiryDate = dayjs(mortgage.activeSubmission?.aipExpiryDate, 'YYYY-MM-DD')

        if (aipExpiryDate.isBefore(dayjs())) {
            aipState = 'expired'
        }
        else if (aipExpiryDate.subtract(3, 'week').isBefore(dayjs())) {
            aipState = 'expiring'
        }
    }
    if (mortgage.activeSubmission?.loanOfferExpiryDate) {
        let loanOfferExpiry = dayjs(mortgage.activeSubmission?.loanOfferExpiryDate, 'YYYY-MM-DD')
        if (loanOfferExpiry.isBefore(dayjs())) {
            loanOfferState = 'expired'
        } else if (loanOfferExpiry.subtract(4, 'week').isBefore(dayjs())) {
            loanOfferState = 'expiring'
        }
    }
    // if newBuild purchase, the first valuation is formality and should be ignored, the second valuation is always the one that matter. This is the only one impacted by closingDate
    // this is to warn the admin that the active aluation is
    let valuationExpiring = false
    let valuation2Expiring = false
    const valuation2Instructed = mortgage.property?.valuation2Instructed
    if (!newBuild) {
        if (valuationExpiry && !valuation2Instructed ) {
            if (valuationExpiry.subtract(2,'weeks').isBefore(dayjs())) {
                valuationExpiring = valuationExpiry
            }
        }
    }
    if (valuation2Expiry){
        if (valuation2Expiry.subtract(2,'weeks').isBefore(dayjs())) {
            valuation2Expiring = valuation2Expiry
        }
    }

    const rateChangedInApproval = (()=>{
        if (mortgage.applicationStage === ApplicationStages.APPROVAL){
            const selectedProductId = mortgage?.activeSubmission?.finalRateId || mortgage?.activeSubmission?.provisionalRateId
            const rateFloat =  parseFloat(mortgage?.activeSubmission?.finalRate || mortgage?.activeSubmission?.provisionalRate || 0)
            const selectedProduct = currentRates.find(rate => rate.id === selectedProductId)
            if (rateFloat !== selectedProduct?.rate ) {
                return true
            }
        }
        return false
    })()
    const needsNewAlignmentDate = (()=>{
        if (['APPLY',"SIGN"].includes(mortgage.applicationStage)) {
            if (!mortgage.activeSubmission?.completedFlowItems?.ApplicationSubmitted) {
                if (mortgage?.requirement?.statementAlignmentDate){
                    const sad = dayjs(mortgage.requirement.statementAlignmentDate).add(1,'month')
                    if (sad.isBefore(today)){
                        return true
                    }
                }
            }
        }
        return false
    })()


    // what's the benefit to savings expected AIP date?
    const userComplete = (attr, submissionID) => {
        let on
        if (submissionID) {
            let submission = mortgage.submissions.find(a => a.id === submissionID)
            if (submission.completedFlowItems?.hasOwnProperty(attr)) {
                on = dayjs(submission.completedFlowItems[attr])
            }
        } else {
            if (mortgage.completedFlowItems?.hasOwnProperty(attr)) {
                on = dayjs(mortgage.completedFlowItems[attr])
            }
        }

        if (dayjs.isDayjs(on) && on?.isValid()) {
            return {
                on,
                by: 'user'
            }
        }
        return false
    }
    const adminComplete = (attr, submissionID = null) => {
        let on
        let by
        if (submissionID) {
            let submission = mortgage.submissions.find(a => a.id === submissionID)
            if (submission.completedFlowItemsForAdmin?.hasOwnProperty(attr)) {
                on = dayjs(submission.completedFlowItemsForAdmin[attr].on)
                by = submission.completedFlowItemsForAdmin[attr].by
            }
        } else {
            if (mortgage.completedFlowItemsForAdmin?.hasOwnProperty(attr)) {
                on = dayjs(mortgage.completedFlowItemsForAdmin[attr].on)
                by = mortgage.completedFlowItemsForAdmin[attr].by
            }
        }
        if (dayjs.isDayjs(on) && on?.isValid()) {
            return {
                on,
                by
            }
        }
        return false
    }
    const lenderCode = mortgage.activeSubmission?.lenderCode || mortgage?.requirement?.lenderCode
    const ItemsDone = itemsDoneBySubmission(mortgage.activeSubmission?.id)
    const LenderFlowDefaults = lenderFlowDefaults(lenderCode)

    // Object.keys(ItemsDone.AdminSource).forEach(key => {
    // 	let [title, submissionID, dbKey] = ItemsDone.AdminSource[key]
    // 	ItemsDone.Admin[key] = adminComplete(dbKey || key, submissionID)
    // })
    const Map = {
        Admin: {},
        User: {}
    }
    Object.keys(ItemsDone.AdminSource).forEach(key => {
        let [title, submissionID, dbKey] = ItemsDone.AdminSource[key]
        Map.Admin[key] = {
            delayKey: submissionID ? `s:${submissionID}:${key}` : key,
            title,
            dbKey: dbKey || key,
            isAdmin: true,
            done: adminComplete(dbKey || key, submissionID),
            submissionID,
            name: key,
        }
    })
    Object.keys(ItemsDone.UserSource).forEach(key => {
        let [title, submissionID, dbKey] = ItemsDone.UserSource[key]
        Map.User[key] = {
            title,
            delayKey: submissionID ? `${submissionID}:${key}` : key,
            dbKey: dbKey || key,
            isAdmin: false,
            done: userComplete(dbKey || key, submissionID),
            name: key,
        }
        if (submissionID) {
            Map.User[key].submissionID = submissionID
        }
    })

    const QualificationSteps = () => {

        const affordabilityComplete1 = (mortgage.questionPercentApp1Setup === 100 && mortgage.questionPercentGeneralSetup ===100) || mortgage.applicationStage !== ApplicationStages.SETUP
        const affordabilityComplete2 = !mortgage.twoApplicants || mortgage.questionPercentApp2Setup === 100 || mortgage.applicationStage !== ApplicationStages.SETUP
        const affordabilityComplete = affordabilityComplete1 && affordabilityComplete2
        //const affordabilityComplete= mortgage.questionPercentGeneralSetup === 100 && (mortgage.twoApplicants ? (mortgage.questionPercentApp1Setup === 100 && mortgage.questionPercentApp2Setup === 100) : mortgage.questionPercentApp1Setup === 100)
        const readyForAffordabilityIncompleteMessage = loggedOut && !affordabilityComplete && !dontContact


        const qualificationNotSet = !mortgage.qualification
        const qualificationByAdvisorNeeded = mortgage.qualification === MortgageQualificationStatus.MAYBE
        const qualificationConfirmedByAdvisor = mortgage.qualificationConfirmed
        const steps = []
        // INCOMPLETE
        if (readyForAffordabilityIncompleteMessage || Map.Admin.incompleteEmailSent.done) {
            steps.push({
                ...Map.Admin.incompleteEmailSent,
                due: lastTimeSomeoneWasHere ? lastTimeSomeoneWasHere.add(7, 'day') : false,
                for: 'support',
            })
        }
        if ((readyForAffordabilityIncompleteMessage && Map.Admin.incompleteEmailSent.done) || Map.Admin.incompleteReminderEmailSent.done) {
            steps.push({
                due: Map.Admin.incompleteEmailSent.done?.on?.startOf('day').add(7, 'day') ?? false,
                for: 'support',
                ...Map.Admin.incompleteReminderEmailSent,
            })
        }
        // AFFORDABILITY TESTED
        steps.push({
            due: affordabilityComplete && mortgage.applicationStage === ApplicationStages.SETUP,
            for: 'support',
            ...Map.Admin.initialAffordabilityTested,
        })
        if (qualificationByAdvisorNeeded || qualificationConfirmedByAdvisor) {
            steps.push({
                due: Map.Admin.initialAffordabilityTested.done && (qualificationByAdvisorNeeded || qualificationConfirmedByAdvisor),
                for: 'advisor',
                title: 'Manual Qualification Needed',
                description: 'Client needs manual review to determine qualification status. Please review and set qualification status',
                done: qualificationConfirmedByAdvisor,
                tagLink: `/mortgage/${mortgage.id}/evaluation/test`,
                importance: 5
            })
        }
        steps.push({
            due: affordabilityComplete && !qualificationNotSet && !qualificationByAdvisorNeeded && !dontContact && ['SETUP', 'APPLY'].includes(mortgage.applicationStage),
            for: 'support',
            ...Map.Admin.qualificationEmailSent,
        })
        return steps
    }
    const VerificationSteps = () => {
        const steps = []
        // Incomplete
        let app1_ = mortgage.questionPercentApp1Apply === 100
        let app2_ = !mortgage.twoApplicants || (mortgage.questionPercentApp2Apply === 100)
        let upl_ = mortgage.uploadsPercentApply > 85
        let allDone = app1_ && app2_ && upl_
        const readyForAPPLYIncompleteMessage = !allDone
        if (readyForAPPLYIncompleteMessage || Map.Admin.verificationOutstandingEmailReminder1Sent.done) {
            steps.push({
                due: !Map.User.ApplicationSubmitted.done && (lastTimeSomeoneWasHere ? lastTimeSomeoneWasHere.add(7, 'day') : false),
                for: 'support',
                ...Map.Admin.verificationOutstandingEmailReminder1Sent,
                title: "Send Application Outstanding Items Email 1",
            })
        }
        if ((readyForAPPLYIncompleteMessage && Map.Admin.verificationOutstandingEmailReminder1Sent.done) || Map.Admin.verificationOutstandingEmailReminder2Sent.done) {
            steps.push({
                due: !Map.User.ApplicationSubmitted.done && (Map.Admin.verificationOutstandingEmailReminder1Sent.done?.on?.startOf('day').add(7, 'day') ?? false),
                for: 'support',
                ...Map.Admin.verificationOutstandingEmailReminder2Sent,
                title: "Send Application Outstanding Items Email 2",
            })
        }
        if ((readyForAPPLYIncompleteMessage && Map.Admin.verificationOutstandingEmailReminder2Sent.done) || Map.Admin.verificationOutstandingEmailReminder3Sent.done) {
            steps.push({
                due: !Map.User.ApplicationSubmitted.done && (Map.Admin.verificationOutstandingEmailReminder2Sent.done?.on?.startOf('day').add(7, 'day') ?? false),
                for: 'support',
                ...Map.Admin.verificationOutstandingEmailReminder3Sent,
                title: "Send Application Outstanding Items Email 3",
            })
        }
        steps.push({
            due: !Map.User.ApplicationSubmitted.done && allDone,
            for: 'support',
            ...Map.Admin.signingAffordabilityTested,
        })
        // steps.push({
        //     due: Map.Admin.readyForVerifiedFiguresEvaluation.done,
        //     for: 'support', ...Map.Admin.verifiedFiguresEvaluated,
        //     info: (fullMortgage) => {
        //         const makeAiCells = (n, name) => {
        //             const item = fullMortgage.aiResponses.find(it => it.responseName === `App${n}: Current Accounts: ${name}`)
        //
        //             return [
        //                 <td key={name + '-key-' + n}>
        //                     {item ? item.reaction === 'POSITIVE' ? <CheckSquareOutlined
        //                         style={{color: green[5]}}>Yes</CheckSquareOutlined> : item.reaction === 'NEGATIVE' ?
        //                         <CloseSquareOutlined style={{color: red[5]}}>No</CloseSquareOutlined> :
        //                         <QuestionCircleOutlined style={{color: orange[5]}}/> : null}
        //                 </td>,
        //                 <td>
        //                     {name}
        //                 </td>
        //             ]
        //
        //         }
        //         const names = mortgage.mortgageType === MortgageTypes.REFINANCE ? ['Salary', 'Rent', 'Other Lodgements'] : ['Salary', 'Other Lodgements', 'Savings', 'Rent', 'Loans/Credit Cards', 'General', 'Cross Check']
        //         const makeAiRows = (name) => {
        //             const cells = makeAiCells(1, name)
        //             if (mortgage.twoApplicants) {
        //                 cells.push(...makeAiCells(2, name))
        //             }
        //             return <tr key={name}>
        //                 {cells}
        //             </tr>
        //         }
        //         return (<table>
        //             <tbody>
        //             {names.map((name, index) => makeAiRows(name))}
        //             </tbody>
        //         </table>)
        //     }
        // })
        steps.push({
            due: !Map.User.ApplicationSubmitted.done && Map.Admin.signingAffordabilityTested.done,
            for: 'advisor',
            ...Map.User.callScheduled, //title: 'Check Out Verified Figures Evaluation & Schedule Call',
            info: (fullMortgage) => {
                const existing = fullMortgage.appointments[0]
                if (existing) {
                    return <Tag color="geekblue">Starts: {dayjs(existing.appointmentDate).fromNow()}</Tag>
                }
            },
        })
        steps.push({
            due: !Map.User.ApplicationSubmitted.done && Map.User.callScheduled.done,
            for: 'advisor',
            ...Map.User.chatComplete, // title: 'Record Chat Complete',

        })
        return steps
    }
    const ApplicationSubmissionSteps = () => {
        const steps = []
        // steps.push({
        //     due: !Map.User.ApplicationSubmitted && Map.User.chatComplete.done,
        //     title: 'All Uploads',
        //     done: mortgage.uploadsPercentApply === 100,
        //     info: (fullMortgage) => {
        //         const tags = []
        //         const uploads = fullMortgage.mortgageUploads.apply
        //
        //         const gen = uploads.filter(it => !it.applicant)
        //         if (gen.length) {
        //             let genPercent = Math.round((gen.filter(a => !!a?.record?.sectionChecked || [
        //                 ProgressViewState.COMPLETE, ProgressViewState.HIDDEN
        //             ].includes(a?.record?.viewState)).length / gen.length) * 100)
        //             tags.push(<TagInfo key={"owoosd"} label="Misc"
        //                                color={genPercent === 100 ? "green" : genPercent > 80 ? "orange" : "volcano"}>{genPercent}%</TagInfo>)
        //         } else {
        //             tags.push(<TagInfo key={"fake34"} style={{opacity: 0}}/>)
        //         }
        //
        //         const app1 = uploads.filter(it => it.applicant === 1)
        //         let app1Percent = Math.round((app1.filter(a => !!a?.record?.sectionChecked || [
        //             ProgressViewState.COMPLETE, ProgressViewState.HIDDEN
        //         ].includes(a?.record?.viewState)).length / app1.length) * 100)
        //         tags.push(<TagInfo key={"323fss"} label={mortgage.applicant1.firstName}
        //                            color={app1Percent === 100 ? "green" : app1Percent > 80 ? "orange" : "volcano"}>{app1Percent}%</TagInfo>)
        //         if (mortgage.twoApplicants) {
        //             const app2 = uploads.filter(it => it.applicant === 2)
        //             let app2Percent = Math.round((app2.filter(a => !!a?.record?.sectionChecked || [
        //                 ProgressViewState.COMPLETE, ProgressViewState.HIDDEN
        //             ].includes(a?.record?.viewState)).length / app2.length) * 100)
        //             tags.push(<TagInfo key={"xccmlspw"} label={mortgage.applicant2.firstName}
        //                                color={app2Percent === 100 ? "green" : app2Percent > 80 ? "orange" : "volcano"}>{app2Percent}%</TagInfo>)
        //         }
        //
        //         return <div className="d-row gap-15 j-equal">
        //             {tags}
        //         </div>
        //     }
        // })

        // steps.push({
        //     due: mortgage.uploadsPercentApply > 80 || Map.Admin.signingAffordabilityTested.done,
        //     for: 'advisor', ...Map.Admin.signingAffordabilityTested, // title: 'Verify Lender Test',
        //
        // })
        steps.push({
            due: !Map.User.ApplicationSubmitted.done && Map.Admin.signingAffordabilityTested.done && (!!mortgage.activeSubmission?.lenderCode || !!mortgage?.requirement?.lenderCode),
            for: 'advisor',
            ...Map.Admin.createApplyCustomerDocuments, // title: 'Generate Customer Documents',
        })
        // steps.push({
        //     due: !Map.User.ApplicationSubmitted && Map.Admin.createApplyCustomerDocuments.done,
        //     for: 'advisor',
        //     ...Map.Admin.applyReadyForTransfer, // title: 'Mark Ready for Transfer',
        // })
        steps.push({
            due: !Map.User.ApplicationSubmitted.done && Map.Admin.createApplyCustomerDocuments.done,
            for: 'support',
            ...Map.Admin.applyTransferred, // title: 'Transfer to Broker Assist',
        })
        steps.push({
            due: !Map.User.ApplicationSubmitted.done && Map.Admin.applyTransferred.done,
            for: 'advisor',
            ...Map.User.ApplicationSubmitted, // title: 'Submit Initial Package',
        })
        if (!aipReceived && (!expectedAipDate || expectedAipDate.isBefore(dayjs())) && Map.User.ApplicationSubmitted.done && Map.User.ApplicationSubmitted.done.on.add(LenderFlowDefaults.aipTakingTooLongInDays, 'day').isBefore(dayjs())) {
            steps.push({
                due: Map.User.ApplicationSubmitted.done.on.add(LenderFlowDefaults.aipTakingTooLongInDays, 'day').isBefore(dayjs()),
                for: 'advisor',
                title: 'AIP Taking Too Long',
                done: aipReceived,
            })
        }
        if (needsNewAlignmentDate && !Map.User.ApplicationSubmitted.done){
            steps.push({
                due: true,
                for: 'advisor',
                ...Map.Admin.resetStatementAlignmentDate,
                done: false,
                title: "Move Alignment Date forward 1 month"
            })
        }
        return steps
    }
    const AipReceivedSteps = () => {
        let stage = mortgage.applicationStage
        const readyForValuationNotDone = !['SETUP', 'APPLY', 'SIGN'].includes(stage) && !mortgage.property?.valuationInstructed && propertyFound && loggedOut // &&!Map.User.valuationInstructed.done
        const steps = []
        steps.push({
            due: aipReceived,
            for: 'advisor',
            ...Map.Admin.aipReceivedEmailSent,
        })
        if (aipReceived && !propertyFound && aipExpiry ) {
            //Hurry up and find a property
            steps.push({
                due: aipExpiry ? aipExpiry.subtract(9, 'week') : false,
                for: 'advisor', ...Map.Admin.noPropertyAt2MthFromExpiryEmailSent
                // title: 'Send 9 Weeks to AIP Expiry Email',
            })
        }

        if ((loggedOut && aipReceived && propertyFound && ((!mortgage?.requirement?.hasOwnMPI && !Map.User.healthComplete.done) || mortgage.uploadsPercentPreapproval !== 100 || !Map.User.propertyComplete.done || !Map.User.solicitorComplete.done || !Map.User.productSelectionComplete.done)) || Map.Admin.preapprovedOutstandingItemsEmailSent.done) {
            steps.push({
                due: true,
                for: 'support',
                ...Map.Admin.preapprovedOutstandingItemsEmailSent, // title: 'Send Outstanding Items Email',
            })
        }

        steps.push({
            due: readyForValuationNotDone,
            for: 'advisor',
            ...Map.User.valuationInstructed, title: 'Send Instruct Valuation Reminder Email',
        })
        if (!valuationDocReceived && Map.User.valuationInstructed.done && Map.User.valuationInstructed.done.on.add(12, 'day').isBefore(dayjs())) {
            steps.push({
                due: true,
                for: 'advisor',
                title: 'Valuation Taking Too Long',
                done: false
            })
        }

        steps.push({
            due: valuationDocReceived,
            for: 'advisor',
            ...Map.Admin.preapprovedCustomerDocsGenerated, // title: 'Generate Customer Documents',
        })


        // steps.push({
        //     due: false,
        //     title: 'Loan Offer Uploads',
        //     done: mortgage?.uploadsPercentPreapproval === 100,
        //     info: (fullMortgage) => {
        //         const tags = []
        //         const uploads = fullMortgage.mortgageUploads.preapproval
        //         const gen = uploads.filter(it => !it.applicant)
        //         if (gen.length) {
        //
        //
        //             let done = gen.filter(a => !!a?.record?.sectionChecked || [ProgressViewState.COMPLETE, ProgressViewState.HIDDEN].includes(a?.record?.viewState))
        //
        //             let genPercent = Math.round(done.length / gen.length) * 100
        //             tags.push(<TagInfo key={"s234ag"} label="Misc"
        //                                color={genPercent === 100 ? "green" : genPercent > 80 ? "orange" : "volcano"}>{genPercent}%</TagInfo>)
        //         } else {
        //             tags.push(<TagInfo key={"fak3242"} style={{opacity: 0}}/>)
        //         }
        //
        //         const app1 = uploads.filter(it => it.applicant === 1)
        //         if (app1.length > 0) {
        //             let app1Percent = Math.round((app1.filter(a => !!a?.record?.sectionChecked || [ProgressViewState.COMPLETE, ProgressViewState.HIDDEN].includes(a?.record?.viewState)).length / app1.length) * 100)
        //             tags.push(<TagInfo key={"fasdfk3242"} label={mortgage.applicant1.firstName}
        //                                color={app1Percent === 100 ? "green" : app1Percent > 80 ? "orange" : "volcano"}>{app1Percent}%</TagInfo>)
        //         }
        //         if (mortgage.twoApplicants) {
        //             const app2 = uploads.filter(it => it.applicant === 2)
        //             if (app2.length > 0) {
        //                 let app2Percent = Math.round((app2.filter(a => !!a?.record?.sectionChecked || [ProgressViewState.COMPLETE, ProgressViewState.HIDDEN].includes(a?.record?.viewState)).length / app2.length) * 100)
        //                 tags.push(<TagInfo key={"fak324sdf22"} label={mortgage.applicant2.firstName}
        //                                    color={app2Percent === 100 ? "green" : app2Percent > 80 ? "orange" : "volcano"}>{app2Percent}%</TagInfo>)
        //             }
        //         }
        //
        //         return <div className="d-row gap-15 j-equal">
        //             {tags}
        //         </div>
        //     }
        // })


        steps.push({
            due: Map.Admin.preapprovedCustomerDocsGenerated.done && valuationDocReceived && mortgage.uploadsPercentPreapproval === 100,
            for: 'advisor', ///title: 'Package Loan Offer Request',
            ...Map.Admin.preapprovedPackaged,
        })
        steps.push({
            due: Map.Admin.preapprovedPackaged.done,
            for: 'advisor',
            ...Map.User.LoanOfferSubmitted,
            //done: !!loanOfferReceived,

        })
        steps.push({
            due: Map.Admin.preapprovedPackaged.done,
            for: 'advisor', //title: 'Send Loan Request Lodged Email',
            ...Map.Admin.loanOfferRequestedEmailSent,
        })
        if (!loanOfferReceived && Map.Admin.preapprovedPackaged.done) {
            steps.push({
                due: Map.Admin.preapprovedPackaged.done.on.add(LenderFlowDefaults.loanOfferRequestTakingTooLongInDays, 'days'),
                for: 'advisor',
                title: 'Loan Offer Request Taking Too Long',
                done: false,
            })
        }
        if (!loanOfferReceived && aipState) {
            steps.push({
                due: true,
                for: 'advisor', ...Map.Admin.aipAboutToExpiryEmailSent,
                title: `Send AIP to Expire on ${aipExpiry.format('D MMM YYYY')} Email`,
            })
        }
        if (valuationExpiring) {
            steps.push({
                due: true,
                for: 'advisor', ...Map.Admin.valuationAboutToExpiryEmailSent,
                title: `Send Valuation to Expire on ${valuationExpiring.format('D MMM YYYY')} Email`,
            })
        }
        if (valuation2Expiring) {
            steps.push({
                due: true,
                for: 'advisor', ...Map.Admin.valuation2AboutToExpiryEmailSent,
                title: `Send Valuation to Expire on ${valuation2Expiring.format('D MMM YYYY')} Email`,
            })
        }

        return steps
    }
    const LoanOfferReceivedSteps = () => {
        const steps = []
        steps.push({
            due: loanOfferReceived,
            for: 'advisor', //title: 'Send Loan Offer Received Email',
            ...Map.Admin.loanOfferReceivedEmailSent,

        })



        steps.push({
            due: Map.Admin.loanOfferReceivedEmailSent.done,
            for: 'advisor',
            title: 'Confirm Closing Date',
            done: !!drawdownDate,
            info: (fullMortgage) => {
                if (drawdownDate) {
                    return <Tag color="green">{drawdownDate.format('D MMM YYYY')}</Tag>
                }
            }
        })
        if (rateChangedInApproval){
            steps.push({
                due: true,
                for: 'advisor',
                ...Map.Admin.rateChangedWhilstInApprovalEmailSent,
            })
        }


        steps.push({
            due: Map.Admin.approvedCustomerDocumentsGenerated.done,
            for: 'advisor', //title: 'Generate Lender Documents',
            ...Map.Admin.approvedAdminDocsGenerated,
        })
        steps.push({
            due: true,
            title: 'Closing Uploads',
            done: mortgage?.uploadsPercentApproval === 100,
            info: (fullMortgage) => {
                const tags = []
                const uploads = fullMortgage.mortgageUploads.approval

                const gen = uploads.filter(it => !it.applicant)
                if (gen.length) {
                    let genPercent = Math.round((gen.filter(a => !!a?.record?.sectionChecked || [ProgressViewState.COMPLETE, ProgressViewState.HIDDEN].includes(a?.record?.viewState)).length / gen.length) * 100)
                    tags.push(<TagInfo key={"fak3sdfs242"} label="Misc"
                                       color={genPercent === 100 ? "green" : genPercent > 80 ? "orange" : "volcano"}>{genPercent}%</TagInfo>)
                } else {
                    tags.push(<TagInfo key={"fdsake35"} style={{opacity: 0}}/>)
                }

                const app1 = uploads.filter(it => it.applicant === 1)
                if (app1.length > 0) {
                    let app1Percent = Math.round((app1.filter(a => !!a?.record?.sectionChecked || [ProgressViewState.COMPLETE, ProgressViewState.HIDDEN].includes(a?.record?.viewState)).length / app1.length) * 100)
                    tags.push(<TagInfo key={"fakewew113242"} label={mortgage.applicant1.firstName}
                                       color={app1Percent === 100 ? "green" : app1Percent > 80 ? "orange" : "volcano"}>{app1Percent}%</TagInfo>)
                }
                if (mortgage.twoApplicants) {
                    const app2 = uploads.filter(it => it.applicant === 2)
                    if (app2.length > 0) {
                        let app2Percent = Math.round((app2.filter(a => !!a?.record?.sectionChecked || [ProgressViewState.COMPLETE, ProgressViewState.HIDDEN].includes(a?.record?.viewState)).length / app2.length) * 100)
                        tags.push(<TagInfo key={"fak32432322"} label={mortgage.applicant2.firstName}
                                           color={app2Percent === 100 ? "green" : app2Percent > 80 ? "orange" : "volcano"}>{app2Percent}%</TagInfo>)
                    }
                }

                return <div className="d-row gap-15 j-equal">
                    {tags}
                </div>
            }
        })
        //changed from 8 weeks to 2 weeks at Kev;s request on 30.03 via skype
        let approvedPackedDue = drawdownDate ? drawdownDate.subtract(2, 'week').isBefore(dayjs()) : false

        steps.push({
            due: approvedPackedDue,
            for: 'advisor', //title: 'Submit Closing Docs',
            ...Map.Admin.approvedPackaged,
        })
        steps.push({
            due: Map.Admin.approvedPackaged.done,
            for: 'advisor', ///title: 'Send Closing Docs Lodged Email',
            ...Map.Admin.closingDocsEmailSent,
        })

        steps.push({
            due: drawdownDate && drawdownDate.endOf('day').isBefore(dayjs()),
            for: 'advisor', //title: 'Send Mortgage Complete Email',
            ...Map.Admin.mortgageCompleteEmailSent,
        })

        if (loanOfferState) {
            steps.push({
                due: Map.Admin.loanOfferAboutToExpiryEmailSent.done || loanOfferState,
                for: 'advisor',
                ...Map.Admin.loanOfferAboutToExpiryEmailSent,
                title: `Send Loan Offer to Expire on ${loanOfferExpiry.format('D MMM YYYY')} Email`,
            })
            if (loanOfferExpiry.subtract(2, 'weeks').isBefore(dayjs())) {
                steps.push({
                    due: true,
                    for: 'advisor',
                    ...Map.Admin.initiateLoanOfferExtension
                })
            }
        }

        if (drawdownDate) {

            if (drawdownDate.isBefore(dayjs())) {
                steps.push({
                    due: true,
                    for: 'advisor',
                    title: `Update Drawdown Date or Mark Complete`,
                    done: mortgage.applicationStatus === ApplicationStatuses.COMPLETED,
                })
            }
            let due = false
            let ddDate = mortgage.activeSubmission?.drawdownDate ? dayjs(mortgage.activeSubmission?.drawdownDate, 'YYYY-MM-DD') : null
            let fixedTerm = mortgage.activeSubmission?.finalFixedTerm || mortgage.activeSubmission?.provisionalFixedTerm

            if (ddDate && fixedTerm) {
                let fallOffDate = ddDate.add(fixedTerm, 'years').subtract(1, "month")
                due = fallOffDate.isBefore(today)
                steps.push({
                    due: due,
                    for: 'advisor',
                    ...Map.Admin.fixedRateFallingOffEmailSent,
                    title: `Send Fixed rate to fall off on ${fallOffDate.format('D MMM YYYY')} Email`,
                })
            }

        }

        if (newBuild) {
            if (snagDate) {
                // snag entered so valuation needed now
                steps.push({
                    due: !mortgage.property.valuation2Instructed,
                    for: 'advisor',
                    ...Map.Admin.secondValuationNeededAfterSnagEmailSent,
                })

            }
        }
        return steps
    }
    // waitingFor (MPI steps): what the step is waiting on while it isn't due -
    // shown on the MPI timeline between the last done step and this one. A
    // future due date needs no reason here; the timeline shows "until <date>"
    const MortgageProtectionStepsA = () => {
        const steps = []
        const earlyUnderwriting = mortgage.applicant1?.health?.earlyUnderwriting || (mortgage.twoApplicants && mortgage.applicant2?.health?.earlyUnderwriting)

        if (!mortgage?.requirement?.hasOwnMPI) {
            if ((!dontContact && !Map.User.healthComplete.done && Map.Admin.aipReceivedEmailSent.done) || Map.Admin.healthQuestionsReminderEmailSent.done) {
                steps.push({
                    due: Map.Admin.aipReceivedEmailSent.done.on.add(5, 'day'),
                    for: 'advisor',
                    ...Map.Admin.healthQuestionsReminderEmailSent, // title: 'Send Health Questions Reminder Email',
                    mpi: true,
                    waitingFor: () => 'Client to complete the health questions',
                })
            }
            // second reminder, 10 days after the first, if the questions are still not answered
            if ((!dontContact && !Map.User.healthComplete.done && Map.Admin.healthQuestionsReminderEmailSent.done) || Map.Admin.healthQuestionsReminder2EmailSent.done) {
                steps.push({
                    due: Map.Admin.healthQuestionsReminderEmailSent.done?.on ? dayjs(Map.Admin.healthQuestionsReminderEmailSent.done.on).add(10, 'day') : false,
                    for: 'advisor',
                    ...Map.Admin.healthQuestionsReminder2EmailSent, // title: 'Send Health Questions Reminder 2 Email',
                    mpi: true,
                    waitingFor: () => 'Client to complete the health questions',
                })
            }

            const selectedMpiQuote = mortgage?.selectedMpiQuote

            steps.push({
                for: 'advisor',
                due: Map.User.healthComplete.done && Map.Admin.aipReceivedEmailSent.done,
                ...Map.Admin.mpiQuotesGenerated,
                mpi: true,
                waitingFor: () => !aipReceived
                    ? 'AIP from the lender'
                    : !Map.Admin.aipReceivedEmailSent.done ? 'AIP received email to be sent' : 'Client to complete the health questions',
            })
            steps.push({
                due: Map.Admin.mpiQuotesGenerated.done ,
                title: 'Email MPI Quote',
                for: 'advisor', ...Map.Admin.mpiQuotesEmailSent,
                mpi: true,
                waitingFor: () => 'MPI quotes to be generated',
            })

            steps.push({
                for:'advisor',
                due: (earlyUnderwriting ? Map.Admin.mpiQuotesGenerated.done : drawdownDate ? drawdownDate.clone().subtract(2.2,'week') : false),
                ...Map.Admin.mpiUnderwritingSubmitted,
                mpi: true,
                waitingFor: () => earlyUnderwriting
                    ? 'MPI quotes to be generated (early underwriting)'
                    : !drawdownDate ? 'Drawdown date to be set' : '2.2 weeks before drawdown',
            })

            if (!mortgage?.mpi?.underwritingOutcome && Map.Admin.mpiUnderwritingSubmitted.done){
                steps.push({
                    due: Map.Admin.mpiUnderwritingSubmitted.done.on.clone().add(10, 'day'),
                    for: 'advisor',
                    title: 'Underwriting Taking Too Long',
                    done: false,
                    mpi: true,
                    waitingFor: () => 'Underwriting decision from the insurer',
                })
            }
            // always shown; due as soon as the underwriting outcome is ordinary
            // rates or special terms
            const underwritingOutcome = mortgage?.mpi?.underwritingOutcome
            steps.push({
                due: ['ORDINARY_RATES', 'SPECIAL_TERMS'].includes(underwritingOutcome),
                for: 'advisor',
                ...Map.Admin.mpiUnderwritten,
                mpi: true,
                waitingFor: () => !underwritingOutcome
                    ? 'Underwriting outcome from the insurer'
                    : 'An Ordinary Rates or Special Terms underwriting outcome',
            })
            if (Map.Admin.mpiUnderwritten.done || Map.Admin.mpiFinalised.done) {
              //  console.log({1: Map.Admin.mpiUnderwritten, 2: Map.Admin.mpiFinalised, id: mortgage?.id})
            }


            // if ((!Map.Admin.mpiTranscriptUploaded.done && !selectedMpiQuote && Map.Admin.mpiQuotesEmailSent.done && Map.Admin.mpiQuotesEmailSent.done.on.add(5, 'day').isBefore(dayjs())) || Map.Admin.mpiQuotesReminder1EmailSent.done) {
            //     steps.push({
            //         due: true,
            //         for: 'advisor', //title: 'Select Product Reminder Email',
            //         ...Map.Admin.mpiQuotesReminder1EmailSent,
            //     })
            // }
            //
            // if ((!Map.Admin.mpiTranscriptUploaded.done && !selectedMpiQuote && Map.Admin.mpiQuotesReminder1EmailSent.done && Map.Admin.mpiQuotesReminder1EmailSent.done.on.add(16, 'day').isBefore(dayjs())) || Map.Admin.mpiQuotesReminder2EmailSent.done) {
            //     steps.push({
            //         due: true,
            //         for: 'advisor', //title: 'Select Product Reminder Email',
            //         ...Map.Admin.mpiQuotesReminder2EmailSent,
            //
            //     })
            // }

            // steps.push({
            //     due: Map.Admin.mpiTranscriptUploaded.done, //title: 'Email MPI Transcript',
            //     for: 'advisor', ...Map.Admin.mpiTranscriptEmailSent,
            // })

            // steps.push({
            //     due: Map.Admin.mpiTranscriptEmailSent.done && Map.Admin.mpiTranscriptEmailSent.done.on.add(5, 'days').isBefore(dayjs()), //title: 'Send Confirm Transcript Email',
            //     for: 'advisor', ...Map.User.confirmedMpiTranscript, // TODO
            // })

            // steps.push({
            //     due: Map.User.confirmedMpiTranscript.done, //title: 'Finalise MPI Application',
            //     for: 'advisor',
            //     ...Map.Admin.mpiFinalised, // TODO
            // })

        }


        return steps
    }
    const MortgageProtectionStepsB = () => {
        const selectedMpiQuote = mortgage?.selectedMpiQuote
        const steps = []
        // if (!mortgage?.requirement?.hasOwnMPI) {
        //     steps.push({
        //         due: (Map.Admin.mpiFinalised.done && Map.Admin.mpiFinalised.done.on.add(1, 'day').isBefore(dayjs() && mortgage?.activeSubmission?.drawdownDate ? dayjs(mortgage.activeSubmission?.drawdownDate).subtract(11, 'day').isBefore(dayjs()) : false) || Map.Admin.mpiUnderwritten.done), //title: 'Finalise MPI Application',
        //         for: 'advisor', ...Map.Admin.mpiUnderwritten,
        //     })
        //     steps.push({
        //         // on 21 Mach 2025 Kev asked to change this to 1 week (skype),  was originally 3 week,
        //         due: mortgage?.activeSubmission?.drawdownDate ? dayjs(mortgage.activeSubmission?.drawdownDate).subtract(1, 'week').isBefore(dayjs()) : false, //title: 'Activate Mortgage Protection',
        //         for: 'advisor', ...Map.Admin.mpiActivated
        //     })
        // }


        return steps
    }

    const ClosingDocumentsSteps = () => {
        let steps = []
        steps.push({
            due: false,
            ...Map.Admin.allCustomerClosingDocsComplete
        })
        steps.push({
            due: false,
            ...Map.Admin['uploaded-mortgage-protection-policy-cert']
        })
        steps.push({
            due: false,
            ...Map.Admin['uploaded-statement-of-suitability']
        })
        steps.push({
            due: false,
            ...Map.Admin['uploaded-signed-direct-debit-mandate']
        })
        if (mortgage.activeSubmission?.lenderCode === 'ptsb') {
            steps.push({
                due: false,
                ...Map.Admin['uploaded-signed-pre-drawdown-paye']
            })
            steps.push({
                due: false,
                ...Map.Admin['uploaded-signed-pre-drawdown-self-employed']
            })
        }
        return steps
    }
    const all = {
        "QUALIFICATION": [QualificationSteps()],
        "VERIFICATION": [VerificationSteps()],
        "APPLICATION SUBMISSION": [ApplicationSubmissionSteps()],
        "AIP RECEIVED": [AipReceivedSteps()],
        "LOAN OFFER RECEIVED": [LoanOfferReceivedSteps(), ClosingDocumentsSteps()],
        "MPI_A": [MortgageProtectionStepsA()],
        "MPI_B": [MortgageProtectionStepsB()],
    }
    if (mortgage.id === '3180792c-4270-453b-aabe-5671759be76b'){
        console.log({all})
    }
    return all
}

// Setup, Apply and Sign share one pre-submission list, matching the Pre-Submission column in MortgageNavigation.
// Grouped here rather than as an extra flowRite section, as consumers that walk every section would see each step twice.
const PRE_SUBMISSION_SECTIONS = ['QUALIFICATION', 'VERIFICATION', 'APPLICATION SUBMISSION']
const FLOW_SECTIONS_BY_STAGE = {
    SETUP: PRE_SUBMISSION_SECTIONS,
    APPLY: PRE_SUBMISSION_SECTIONS,
    SIGN: PRE_SUBMISSION_SECTIONS,
    PREAPPROVAL: ['AIP RECEIVED'],
    APPROVAL: ['LOAN OFFER RECEIVED'],
}
export const flowsForStage = (flowHistory, stage) => {
    const sections = FLOW_SECTIONS_BY_STAGE[stage]
    if (!sections || !flowHistory) return undefined
    return sections.flatMap(section => flowHistory[section] || [])
}

function MortgageCompletedFlowItems({children}) {
    const mortgage = useMortgage();
    const setReadyForVerifiedFiguresEvaluation = async () => {
        // are payslips complete

        let payslips = (mortgage.mortgageUploads.setup || []).filter(s => s.name.startsWith('payslips'))
        let payCompleted = payslips.length ? (payslips.every(e => e?.record?.sectionChecked)) : false

        // salaried accounts
        let salariedIdentified = (() => {
            let found = mortgage?.calculatorFigures?.verified?.figures?.applicant1?.works ? [
                ...mortgage.applicant1.accounts, ...mortgage.applicant1.assets
            ].some(a => !!a.salaried) : true
            if (mortgage.twoApplicants && found) {
                found = mortgage?.calculatorFigures?.verified?.figures?.applicant2?.works ? [
                    ...mortgage.applicant2.accounts, ...mortgage.applicant2.assets
                ].some(a => !!a.salaried) : true
            }
            return found
        })()

        let accommodationIdentified = (() => {
            let found = mortgage.calculatorFigures.verified.figures?.applicant1?.pra?.rent || mortgage.calculatorFigures.verified.figures?.applicant1?.pra?.mortgage ? [
                ...mortgage.applicant1.accounts, ...mortgage.applicant1.assets
            ].some(a => !!a.accommodationDD) : true

            if (mortgage.twoApplicants && found) {
                found = mortgage.calculatorFigures.verified.figures.applicant2.pra.rent || mortgage.calculatorFigures.verified.figures.applicant2.pra.mortgage ? [
                    ...mortgage.applicant2.accounts, ...mortgage.applicant2.assets
                ].some(a => !!a.accommodationDD) : true
            }
            return found
        })()

        let notAlreadyMarked = !mortgage.completedFlowItemsForAdmin.hasOwnProperty('readyForVerifiedFiguresEvaluation')

        if (notAlreadyMarked && salariedIdentified && accommodationIdentified && payCompleted) {
            let update = mortgage.completedFlowItemsForAdmin.getMarkCompleteUpdateMutation('readyForVerifiedFiguresEvaluation')

            await mortgage.mutate({update})
        }

    }
    const timers = useRef(null)
    useEffect(() => {
        clearTimeout(timers.current)
        timers.current = setTimeout(setReadyForVerifiedFiguresEvaluation, 1000)
        return () => {

            clearTimeout(timers.current)
        }
    }, []);

    return children;
}

export default MortgageCompletedFlowItems;

